'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HAS_GIVEN_CONSENT_TO_PROCESS = exports.HAS_GIVEN_CONSENT_TO_PROCESS = ['hasVisitorGivenConsentToProcess'];

var HAS_VISITOR_EMAIL = exports.HAS_VISITOR_EMAIL = ['hasVisitorEmail'];